import request from '@/utils/request'

let SignadvApi = {
    /*签到列表*/
    signadvlist(data) {
        return request._post('/shop/plus.signadv.signadv/index', data);
    },
    /*获取档案列表*/
    archiveslist(data) {
        return request._post('/shop/plus.signadv.signadv/archives', data);
    },
    /*用户信息*/
    getUser(data) {
        return request._get('/shop/plus.signadv.signadv/getUser', data);
    },
    /*列表信息*/
    getList(data) {
        return request._get('/shop/plus.signadv.signadv/detailed', data);
    },
    /*绑定商品*/
    putProduct(data) {
        return request._get('/shop/plus.signadv.signadv/putProduct', data);
    },
    /*绑定商品列表*/
    putProductList(data) {
        return request._post('/shop/plus.signadv.signadv/putProductList', data);
    },
    /*取消绑定商品*/
    goRemove(data) {
        return request._get('/shop/plus.signadv.signadv/goRemove', data);
    },

    /*取消绑定商品*/
    putRules(data) {
        return request._post('/shop/plus.signadv.signadv/putRules', data);
    },

    /*取消绑定商品*/
    getSettingList(data) {
        return request._get('/shop/plus.signadv.signadv/getSettingList', data);
    },

    /*****************  Getsignadv 组件 ********************/

    /*商品列表信息*/
    productList(data) {
        return request._post('/shop/plus.signadv.signadv/productList', data);
    },
    /*商品分类信息*/
    categoryList(data) {
        return request._post('/shop/plus.signadv.signadv/categoryList', data);
    },

}
export default SignadvApi;



// WEBPACK FOOTER //
// ./src/api/signadv.js